<template>
  <v-container grid-list-lg v-if="commandDetails">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="elevation-0 transparent">
          <v-card-title>Výrobný príkaz id: {{$route.params.id}}</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="8" md="6" lg="3">
                <v-text-field
                  v-model="commandDetails.name"
                  label="Názov"
                  hint="odporúčaný typ názvu: VP-DURIS"
                  @keyup="save()"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="6" lg="3">
                <v-text-field v-model="commandDetails.description" @keyup="save()" label="Popis"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-data-iterator
          :items="commandDetails.manufacturingDetails"
          :items-per-page.sync="itemsPerPage"
          :footer-props="{ itemsPerPageOptions }"
        >
          <template v-slot:header>
            <v-toolbar color="secondary" class="elevation-1">
              <v-toolbar-title>Položky na výrobnom príkaze</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="black" icon @click="showUnprocessedOrderDetails()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.id" cols="12" sm="6" md="4" lg="2">
                <v-card>
                  <v-card-title>
                    <div
                      class="subtitle-1"
                    >{{ item.orderDetail.storageCard }} - {{item.orderDetail.storageCardId}}</div>
                    <v-spacer></v-spacer>
                    <v-btn color="error" icon @click="deleteItem(item)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-list dense>
                    <CommandDetailListItem
                      name="Skladová karta ID:"
                      :value="item.orderDetail.storageCardId"
                    />
                    <CommandDetailListItem name="Objednávka ID:" :value="item.orderDetail.orderId" />
                    <CommandDetailListItem
                      name="Položka na obj. ID:"
                      :value="item.orderDetail.orderDetailId"
                    />
                    <CommandDetailListItem name="Počet na VP:" :value="item.quantity" type="ks" />
                    <CommandDetailListItem
                      name="Počet v objednávke:"
                      :value="item.orderDetail.quantity"
                      type="ks"
                    />
                    <CommandDetailListItem name="Cena:" :value="item.orderDetail.price" type="€" />
                    <CommandDetailListItem
                      name="Zľava:"
                      :value="item.orderDetail.discount"
                      type="%"
                    />
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <!-- <template v-slot:footer>
            <v-toolbar color="secondary" class="elevation-1">
              <v-toolbar-title class="subheading"></v-toolbar-title>
            </v-toolbar>
          </template>-->
          <template v-slot:no-data>
            <v-alert text type="warning">
              Žiadne položky vo výrobnom príkaze id:
              <strong>{{$route.params.id}}</strong>
            </v-alert>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>

    <OrderDetailsTable ref="orderDetailsDialog" @selected-items="addDetailItems" />
  </v-container>
</template>

<script>
import { debounce } from "lodash-es";
import UnitOfWorkService from "@/services/UnitOfWorkService";
import {
  commandUpdateTableHeader,
  orderDetailsTableHeader
} from "@/views/manufacturing_command/js/tableHeaders";
import CommandDetailListItem from "@/views/manufacturing_command/components/CommandDetailListItem";
import OrderDetailsTable from "@/views/manufacturing_command/components/OrderDetailsTable";

export default {
  name: "CommandUpdate",
  components: { CommandDetailListItem, OrderDetailsTable },
  data() {
    return {
      commandUpdateTableHeader: commandUpdateTableHeader,
      orderDetailsTableHeader: orderDetailsTableHeader,
      unprocessedOrderDetails: [],
      commandDetails: null,
      itemsPerPageOptions: [6, 8, 10, 12],
      itemsPerPage: 6,
      selectedItems: [],
      dialog: false
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .getManufacturingCommand(this.$route.params.id)
        .then(response => {
          this.commandDetails = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    showUnprocessedOrderDetails() {
      this.$refs.orderDetailsDialog.openDialog();
    },

    deleteItem(item) {
      this.openGlobalLoader("Odstraňujem ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .deleteManufacturingCommandDetail(this.$route.params.id, item.id)
        .then(response => {
          console.log(response);
          this.initialize();
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    addDetailItems(items) {
      this.openGlobalLoader("Pridávam ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .putManufacturingCommandAddDetailItems(this.$route.params.id, items)
        .then(response => {
          console.log(response);
          this.initialize();
        })
        .catch(() => {
          this.closeGlobalLoader();
        });
    },

    submit() {
      this.openGlobalLoader("Ukladá sa ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .putManufacturingCommand(this.$route.params.id, this.commandDetails)
        .then(response => {
          console.log(response);
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    save: debounce(function() {
      console.log(this.commandDetails);
      this.submit();
    }, 1000)
  }
};
</script>
